module.exports = __webpack_public_path__ + "images/the-goal-scorer-568831d01bc3ddd1bb92e017fd47c760.png";